// Page Not Found

import { Link } from 'react-router-dom';

const PageNotFound = () => (

	<main className ="page page-not-found">
		<section className="section-wrpper intro">
			<div className="page-info">
				<h1>404...Page Not Found</h1>
			</div>
			<div className="about-text">
				<p>Go to the <Link to={'/'}>home</Link> page.</p>
			</div>
		</section>
	</main>

);

export default PageNotFound;